import React, {useState} from 'react';
import Tabs from './Tabs';
import GeneralTab from './GeneralTab';
import TeamsTab from './TeamsTab';
import NotificationsTab from './NotificationsTab';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('General');

  return (
    <div className="min-h-screen w-full bg-white p-6 flex flex-col justify-start items-start">
      <span className='text-2xl font-semibold text-left'>Settings</span>
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
        <div className="py-6">
          {activeTab === 'General' && <GeneralTab />}
          {activeTab === 'Teams' && <TeamsTab />}
          {activeTab === 'Notifications' && <NotificationsTab />}
        </div>
      </div>

  );
}

export default Settings;
